(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shopable-video"] && !Shopify.designMode) return;
  try {
    
/*
 * Shopable Video — Sound Fix Only
 *
 * الهدف:
 * - الفيديوهات في الكاروسيل تشتغل muted في الخلفية (autoplay عادي)
 * - لما البوكس يتفتح (بواسطة shopable-video.js الأصلي) الفيديو جواه يشتغل بصوته
 * - لو فيديو تاني اتفتح، الأول يتوقف وصوته يتقفل
 * - زرار play/pause وmute جوه البوكس شغالين عادي
 *
 * مش بنتدخل في الـ click أو الـ popup — الثيم يشتغل طبيعي
 * بس بنراقب الـ play event ونظبط الصوت
 */

(function () {

  // ── الفيديو اللي شغال بالصوت دلوقتي ──────────────────────────────
  var activePopupVideo = null;

  // ── خلي كل فيديوهات الكاروسيل تشتغل muted من البداية ───────────
  function initThumbnailVideos() {
    document.querySelectorAll('shopable-video video').forEach(function (v) {
      if (v.dataset.src && !v.src) {
        v.src = v.dataset.src;
        v.load();
      }
      v.muted    = true;
      v.volume   = 0;
      v.loop     = true;
      v.playsInline = true;
      v.dataset.svRole = 'thumbnail';
      v.play().catch(function () {});
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initThumbnailVideos);
  } else {
    setTimeout(initThumbnailVideos, 400);
  }

  document.addEventListener('lazyloaded', function (e) {
    var v = e.target;
    if (!(v instanceof HTMLVideoElement) || !v.closest('shopable-video')) return;
    v.muted  = true;
    v.volume = 0;
    v.loop   = true;
    v.dataset.svRole = 'thumbnail';
    v.play().catch(function () {});
  });

  // ── راقب أي فيديو بيشتغل جوه البوكس (popup) ─────────────────────
  // الثيم بيفتح البوكس ويشغل الفيديو جواه — إحنا بس نظبط الصوت
  document.addEventListener('play', function (e) {
    var v = e.target;
    if (!(v instanceof HTMLVideoElement)) return;

    // لو الفيديو جوه popup (مش thumbnail)
    var isInsidePopup = !!v.closest('.video-item__popup, slide-section-popup, [data-shopable-video-popup]');

    if (isInsidePopup) {
      // وقّف الفيديو اللي كان شغال قبل كده
      if (activePopupVideo && activePopupVideo !== v) {
        try {
          activePopupVideo.pause();
          activePopupVideo.muted  = true;
          activePopupVideo.volume = 0;
        } catch (err) {}
      }

      // شغّل الفيديو الجديد بصوت
      activePopupVideo = v;
      v.muted  = false;
      v.volume = 1;
      return;
    }

    // لو thumbnail — خليه muted دايماً
    if (v.dataset.svRole === 'thumbnail') {
      v.muted  = true;
      v.volume = 0;
    }

  }, true);

  // ── لما البوكس يتقفل، وقّف الفيديو اللي جواه ───────────────────
  // الثيم بيعمل event لما البوكس يتقفل — نستمع عليه
  document.addEventListener('shopable-video:close', function () {
    if (activePopupVideo) {
      try {
        activePopupVideo.pause();
        activePopupVideo.muted  = true;
        activePopupVideo.volume = 0;
      } catch (err) {}
      activePopupVideo = null;
    }
  });

  // Fallback: لو الثيم مش بيعمل event، نراقب لما البوكس يختفي
  var observer = new MutationObserver(function () {
    // لو مفيش popup مفتوح وعندنا activePopupVideo، وقفه
    var openPopup = document.querySelector(
      'slide-section-popup .video-item__popup video'
    );
    if (!openPopup && activePopupVideo) {
      try {
        activePopupVideo.pause();
        activePopupVideo.muted  = true;
        activePopupVideo.volume = 0;
      } catch (err) {}
      activePopupVideo = null;
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // ── امنع thumbnail videos من إنها تشغل صوت أي وقت ──────────────
  document.addEventListener('volumechange', function (e) {
    var v = e.target;
    if (!(v instanceof HTMLVideoElement)) return;
    if (v.dataset.svRole !== 'thumbnail') return;
    // thumbnail دايماً muted
    if (!v.muted || v.volume > 0) {
      v.muted  = true;
      v.volume = 0;
    }
  }, true);

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"] && !Shopify.designMode) return;
  try {
    
  let top_bar = document.querySelector('.section-top-bar')?.clientHeight || 0;
  const body = document.querySelector('body');
  body.style.setProperty('--height-topbar', `${top_bar}px`);

  } catch(e) { console.error(e); }
})();
})();
